import { useQuery } from '@tanstack/react-query';
import { lacAnalyticsService } from '../../../services/LacAnalyticsService';
import { lacQueryKeys } from '../lacQueryKeys';

type UseLacCrawlJobAnalyticsQueryOptions = {
  tenantName: string;
  fromDate: string;
  toDate: string;
  enabled?: boolean;
};

export function useLacCrawlJobAnalyticsQuery({
  tenantName,
  fromDate,
  toDate,
  enabled = true,
}: UseLacCrawlJobAnalyticsQueryOptions) {
  const trimmedTenantName = tenantName.trim();

  return useQuery({
    queryKey: lacQueryKeys.crawlJobAnalytics(
      trimmedTenantName,
      fromDate,
      toDate,
    ),
    enabled:
      enabled &&
      trimmedTenantName.length > 0 &&
      fromDate.length > 0 &&
      toDate.length > 0,
    queryFn: () =>
      lacAnalyticsService.getCrawlJobAnalytics({
        tenantName: trimmedTenantName,
        fromDate,
        toDate,
      }),
  });
}
